module.exports = __webpack_public_path__ + "static/media/eligibility.ac038f56.png";